define('config/routes',['require','underscore','config/pages'],function(require) {
    'use strict';

    var _ = require('underscore'),
        pages = require('config/pages');

    return function(match) {
        match('', 'pages#home');

        match('signout', 'sessions#signout');

        match('404', 'errors#404');
        match('403', 'errors#403');
        match('500', 'errors#500');

        match('login', 'auth#login');

        match('restoration', 'auth#restorationInput');
        match('restoration/:token', 'auth#restorationConfirm');

        match('registration', 'auth#registrationInput');
        match('registration/:token', 'auth#registrationConfirm');

        _.forEach(pages, function(page) {
            var routes = page.routes;
            if (routes) {
                _.each(routes, function(route) {
                    match(route.pattern, route.action || page.action, route.options);
                });
            } else {
                match(page.name, page.action);
            }

        });
    };
});
